<template>
	<v-touch class="frame">
		<div class="container-box">
			<!-- 顶部 -->
			<div class="header" v-if="source == null">
				<tabBar class="tabBarStyle"></tabBar>
			</div>
			<!-- 内容 -->
			<div class="content" :style="{marginTop:source == null? '7.5vh': '0vh'}">
				<van-swipe :autoplay="3000" :height="192" indicator-color="black">
					<van-swipe-item default="1" v-for="(item, index) in bankImg" :key="index">
						<img :src="item.img" style="width: 100%;height: 192px;" mode="scaleToFill" />
					</van-swipe-item>
				</van-swipe>
				<!-- <p style="text-align: center;font-size: 30px;font-weight: 600;margin-top: 10px;">消费助贷申请</p> -->
				<van-form @submit="onSubmit">
					<van-field v-model="loanApplication.userName" name="姓名" label="姓名" placeholder="姓名"
						:rules="[{ required: true, message: '请填写姓名' }]" />
					<van-field readonly clickable label="性别" :value="loanApplication.gender" placeholder="选择性别"
						@click="showPicker = true" />
					<van-popup v-model="showPicker" round position="bottom">
						<van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
					</van-popup>
					<van-field v-model="loanApplication.phone" name="电话" label="电话" placeholder="电话"
						:rules="[{ required: true, message: '请填写电话' }]" />
					<van-field readonly clickable name="datePicker" :value="loanApplication.birthDate" label="出生日期"
						placeholder="点击选择时间" @click="showPickerData = true" />
					<van-field v-model="loanApplication.occupation" name="职业" label="职业" placeholder="职业"
						:rules="[{ required: true, message: '请填写职业' }]" />
					<van-field v-model.number="loanApplication.income" name="收入" label="收入" placeholder="收入"
						:rules="[{ required: true, message: '请填写收入' }]" />
					<van-popup v-model="showPickerData" position="bottom">
						<van-datetime-picker type="date" @confirm="onConfirmData" @cancel="showPickerData = false"
							:min-date="minDate" :max-date="maxDate" />
					</van-popup>
					<van-field v-model="loanApplication.backName" name="银行卡名称" label="银行卡名称" placeholder="银行卡名称"
						:rules="[{ required: true, message: '请填写银行卡名称' }]" />
					<van-field v-model="loanApplication.backCard" name="银行卡号" label="银行卡号" placeholder="银行卡号"
						:rules="[{ required: true, message: '请填写银行卡号' }]" />
					<van-field v-model="loanApplication.idNumber" name="身份证号" label="身份证号" placeholder="身份证号"
						:rules="[{ required: true, message: '请填写身份证号' }]" />
					<van-field name="backPath" label="银行卡照片">
						<template #input>
							<van-uploader v-model="backPath" :max-count="1" :after-read="afterRead" />
						</template>
					</van-field>
					<van-field name="idNumberPath" label="身份证正面">
						<template #input>
							<van-uploader v-model="idNumberPath" :max-count="1" :after-read="afterRead2" />
						</template>
					</van-field>
					<van-field name="idNumberPathUn" label="身份证反面">
						<template #input>
							<van-uploader v-model="idNumberPathUn" :max-count="1" :after-read="afterRead3" />
						</template>
					</van-field>
					<van-field v-model="loanApplication.address" name="居住地址" label="居住地址" placeholder="居住地址" type="textarea"
						:rules="[{ required: true, message: '请填写居住地址' }]" />
					<van-field name="idNumberPathUn" label="注意事项">
						<template #input>
							<div style="width:100%;box-sizing: border-box;overflow-x: scroll;">
								<div class="text-container" v-html="textValue"
									style="height: 200px; background-color: rgb(241,241,241); line-height: 1.5; overflow: auto;">
								</div>
							</div>
						</template>
					</van-field>
					<div style="display: flex;margin-top: 20px;align-items: center;justify-content: center;">
						<van-radio-group v-model="radio">
							<van-radio name="2" icon-size="17px" style="margin-right: 10px;"></van-radio>
						</van-radio-group>
						<span style="font-size: 16px;line-height: 1;">已阅读并了解隐私政策</span>
					</div>
					<div style="display: flex;justify-content: center;align-items: center;margin-bottom: 10px;">
						<van-button round block type="info" native-type="submit"
							style="width: 100px;border-radius: 40px;background-color: rgb(62,133,255);">提&nbsp;&nbsp;交</van-button>
					</div>
				</van-form>
			</div>
			<fixedBottomRight v-if="source == null"></fixedBottomRight>
		</div>
	</v-touch>
</template>

<script>
import {
	Toast
} from 'vant';
import 'vant/lib/picker/style';
import OSS from "ali-oss";
import tabBar from "../../assembly/tabBarNew.vue";
import swiper from "../../assembly/mobileSwiperNew.vue";
import swiperText from '@/components/iphone/test.vue';
import fixedBottomRight from '@/assembly/fixedBottomRight.vue';
import {
	saveLoanApplication
} from "../../api/home.js";
export default {
	name: "loanApplication",
	data() {
		return {
			textValue: '<p style="display: flex;justify-content: center;">E法通金融隐私政策</p><p>&nbsp;</p><p style="display: flex;justify-content: end;">更新日期：2023年9月30日</p><p style="display: flex;justify-content: end;">生效日期：2023年10月6日</p><p>E法通金融（以下或称“我们”）非常注重保护用户（“您”）的个人信息及隐私，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们通过本隐私政策向您清晰地介绍在使用我们的相关产品/服务时，我们如何收集、使用、处理、或分享您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式。本政策有特别规定的，以本政策为准；本政策未载明之处，请参照《E法通隐私政策》。如您对本隐私政策有任何疑问，您可以通过本政策“如何联系我们”中提供的方式与我们联系。</p><p>本政策将帮助您了解以下内容：</p><p>一、 概述</p><p>二、 我们如何收集信息</p><p>三、 我们如何使用Cookie、Beacon、Proxy等技术</p><p>四、 我们如何存储和保护信息</p><p>五、 我们如何使用信息</p><p>六、 我们如何对外提供信息</p><p>七、 您如何访问和管理自己的信息</p><p>八、 如何联系我们</p><p>九、 未成年人的个人信息保护</p><p>十、 本政策的适用及修订更新</p><p>十一、&nbsp; 本政策中关键词说明</p><p>&nbsp;</p><p>&nbsp;</p><p>一、 概述</p><p>我们深知个人信息对您而言的重要性，也感谢您对我们的信任。本政策与您使用我们的相关产品/服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款和敏感个人信息，采用粗体字进行标注以提示您注意。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。</p><p>我们将通过本政策向您说明我们会如何收集、存储、保护、使用及对外提供您的信息，并说明您享有的权利，其中要点如下：</p><p>1.&nbsp;E法通金融的产品/服务是指E法通金融及技术服务提供者通过E法通、大众点评等网站、客户端以及小程序等途径向您提供的金融产品/服务。</p><p>2.&nbsp;为了便于您了解您在使用我们的服务时，我们需要收集的信息类型与用途，我们将结合具体服务向您逐一说明。</p><p>3.&nbsp;为了向您提供服务所需，我们会按照合法、正当、必要的原则收集您的信息。</p><p>4.&nbsp;如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规、国家标准或行业标准（如有）的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。</p><p>5.&nbsp;如果为了向您提供服务而需要从第三方获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性；如果我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权范围，我们将征得您的明确同意。</p><p>6.&nbsp;您可以通过本政策介绍的方式访问和管理您的信息、设置隐私功能、注销您在E法通金融的账户或进行投诉举报。</p><p>&nbsp;</p><p>二、 我们如何收集信息</p><p>在您使用E法通金融以下各项产品/服务的过程中，我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账户和资金安全以及符合国家法律法规及监管规定：</p><p>1.&nbsp;&nbsp;依据法律法规及监管规定履行反洗钱义务及进行实名制管理</p><p>（1）您在注册E法通账号后，可以主动开通E法通金融服务功能。您在使用E法通金融相关产品/服务时，需提供手机号码或者账号名称作为账户登录名。当您开通或使用E法通金融支付账户或使用支付服务时，根据中国人民银行《非银行支付机构网络支付业务管理办法》、《支付机构反洗钱和反恐怖融资管理办法》、《互联网金融从业机构反洗钱和反恐怖融资管理办法》相关法律法规的要求，您需要提供您的身份基本信息，包括姓名、国籍、性别、联系方式以及有效身份证件的种类、号码和有效期限。身份信息中包含您的个人敏感信息，如您不提供前述信息，可能无法注册E法通金融支付账户或无法使用支付相关产品/服务。根据相关法律法规的规定，您需通过身份基本信息多重交叉验证后方可提升余额付款交易累计额度或使用账户余额购买投资理财等金融类产品。身份基本信息外部验证渠道包括政府部门数据库、商业银行信息系统及商业化数据库。其中，如果您选择通过商业银行信息系统验证身份基本信息的，则需要提供您的Ⅰ类银行账户或信用卡信息及银行预留手机号，以便完成验证。如您不提供前述信息，可能无法使用需要通过多重交叉验证后方可使用的部分服务，但不影响您使用我们提供的其他服务；</p><p>（2）我们需根据《中华人民共和国反洗钱法》、《中华人民共和国反恐怖主义法》、《支付机构反洗钱和反恐怖融资管理办法》相关反洗钱法律法规及监管要求，提示您适时提供有效身份证件的彩色影印件或照片以供我们核对并留存；如您不提供前述彩色影印件、照片或不同意我们留存，可能无法使用与监管要求相关的部分服务，但不影响您使用我们</p>',
			radio: false,
			userName: "",
			phone: "",
			project: "",
			cooperation: "",
			tabBarTitle: "",
			tabBarTitle1: "",
			introduceFont: `\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩数智科技有限公司（简称“山哩数智”）成立于2022年5月，是一家专注于个贷不良资产智能化运营的科技创新型企业。公司以“数智科技+大数据”为双引擎，为个贷不良资产提供全产业链管理服务。
公司自主研发的“E法通”智能系统，基于S2B2C案源供应链模式，集资产评估、智能分案与司法调解于一体，构建了覆盖全流程的数字化解决方案。
作为山哩控股集团的核心业务主体，山哩数智已完成全国化战略布局，控股河北、湖南、安徽、陕西、河南、江苏、广西等多家区域子公司，形成覆盖全国的规模化运营网络。`,
			enterpriseVision: "引领新消费、新经济、新业态;让中国新经济产业走向世界",
			governmentFont: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩科技的快速成长, 离不开党和国家的各项优惠政策, 更离不开各级政府领导的亲切关怀。公司成立以来各级政府领导多次对公司进行业务指导, 并对山哩科技的发展给予高度的肯定和赞赏, 鼓舞着山哩人乘风破浪勇往直前",
			list: [],
			name: '',
			email: '',
			// 设置一些图片的链接
			images: [
				"https://picsum.photos/id/10/500/300",
				"https://picsum.photos/id/20/500/300",
				"https://picsum.photos/id/30/500/300",
				"https://picsum.photos/id/40/500/300",
			],
			// 轮播图
			bankImg: [
				{
					img: require('../../assets/bank/loan.jpg')
				},
				{
					img: require('../../assets/bank/rural.jpg')
				},
				{
					img: require('../../assets/bank/guizhou.jpg')
				}
			],
			// 设置一些swiper的选项
			swiperOptions: {
				// 开启分页指示器
				pagination: {
					el: ".swiper-pagination",
				},
				// 开启循环播放
				loop: true,
				// 开启自动播放
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
			},
			loanApplication: {
				userName: "",
				gender: "",
				phone: "",
				birthDate: "",
				backCard: "",
				backName: "",
				backPath: "",
				idNumber: "",
				idNumberPath: "",
				idNumberPathUn: "",
				address: "",
				occupation: "",
				income: ""
			},
			showPicker: false,
			columns: ['男', '女', '未知'],
			showPickerData: false,
			minDate: new Date(1970, 0, 1),
			maxDate: new Date(2005, 11, 1),
			backPath: [],
			idNumberPath: [],
			idNumberPathUn: [],
			client: {},
			result: "",
			source: null
		};
	},
	components: {
		tabBar,
		swiper,
		swiperText,
		fixedBottomRight
	},
	created() {
		this.createOss();
		this.source = this.$route.query.source;
		console.log("来源：" + this.source)
	},
	methods: {

		async createOss() {
			// 实例化OSS
			this.client = await new OSS({
				region: "oss-cn-hangzhou",
				accessKeyId: "LTAI5tRpgjyrKRTcSm35eUmn",
				accessKeySecret: "rQcFUSfLSUS1AuPiuLagiuKojeTrNk",
				bucket: "shanliguanwang",
			});
		},
		onSubmit(values) {
			if (!this.radio) {
				this.$message({
					message: '请勾选隐私政策',
					type: 'warning',
					offset: window.screen.height / 2
				});
				return;
			}
			saveLoanApplication(this.loanApplication).then((res) => {
				if (res.code == 200) {
					this.loanApplication = {
						userName: "",
						gender: "",
						phone: "",
						birthDate: "",
						backCard: "",
						backName: "",
						backPath: "",
						idNumber: "",
						idNumberPath: "",
						idNumberPathUn: "",
						address: "",
						occupation: "",
						income: ""
					}
					this.backPath = [];
					this.idNumberPath = [];
					this.idNumberPathUn = [];
					this.$message({
						message: '提交成功',
						type: 'success',
						offset: window.screen.height / 2
					});
				}
			})
		},
		onConfirm(value) {
			this.loanApplication.gender = value;
			this.showPicker = false;
		},
		onConfirmData(value) {
			this.loanApplication.birthDate = this.format(value, 'yyyy-MM-dd');
			this.showPickerData = false;
		},
		format(date, fmt) {
			var o = {
				"M+": date.getMonth() + 1, //月份 
				"d+": date.getDate(), //日 
				"h+": date.getHours(), //小时 
				"m+": date.getMinutes(), //分 
				"s+": date.getSeconds(), //秒 
				"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
				"S": date.getMilliseconds() //毫秒 
			};
			//(y+)匹配多个y，比如yyyy
			if (/(y+)/.test(fmt)) {
				// RegExp.$1是RegExp的一个属性,指的是与正则表达式匹配的第一个 子匹配(以括号为标志)字符串
				fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
			}
			for (var k in o) {
				if (new RegExp("(" + k + ")").test(fmt)) {
					fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
						.length)));
				}
			}
			return fmt;
		},
		afterRead(file) {
			this.ossUpload(file, 1);
		},
		afterRead2(file) {
			this.ossUpload(file, 2);
		},
		afterRead3(file) {
			this.ossUpload(file, 3);
		},
		async ossUpload(file, type) {
			Toast.loading({
				message: "上传中...",
				forbidClick: true,
				duration: 0, //值为 0 时，toast 不会消失
				overlay: true, //是否显示背景遮罩层
			});
			const result = await this.client.put('file/' +
				new Date().getTime() + ".jpg",
				file.file
			);
			Toast.clear();
			if (type == 1) {
				this.loanApplication.backPath = result.url;
			} else if (type == 2) {
				this.loanApplication.idNumberPath = result.url;
			} else if (type == 3) {
				this.loanApplication.idNumberPathUn = result.url;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.frame {
	position: absolute;
	height: 100%;
	width: 100%;
	touch-action: pan-y !important;
}

.container-box {
	display: flex;
	flex-direction: column;

	.imgStyle {
		height: 100%;
		width: 100%;
	}

	.header {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: fixed;
		background-color: #fff;
		height: 7.5vh;
		width: 100%;
		z-index: 999;
		opacity: 0.85;

		.headerChild {
			height: 59%;
			width: 100vw;
		}

		.tabBarFontFrame {
			pointer-events: none;
			color: #fff;
			height: 5vh;
			width: 100%;
			position: absolute;
			top: 24vh;
			z-index: 3;
			display: flex;
			align-items: center;
			flex-direction: column;

			.tabBarFont {
				letter-spacing: 2px;
				font-weight: bold;
				font-size: 1.3rem;
			}

			.tabBarFont1 {
				margin-top: 2%;
				font-size: 1rem;
				letter-spacing: 2px;
			}
		}
	}

	.content {
		margin-top: 7.5vh;
		width: 100vw;

		.form {
			display: flex;
			flex-direction: column;
			/* align-items: center; */
			padding: 10px;
			border-radius: 5px;
			max-width: 100%;
		}

		.form-title {
			font-size: 28px;
			margin-bottom: 20px;
			text-align: center;
		}

		.form-group {
			margin: 10px 0;
			display: flex;
			flex-direction: column;
			max-width: 100%;
		}

		label {
			font-weight: bold;
			font-size: 18px;
			margin-bottom: 10px;
			display: inline-block;
			width: 120px;
		}

		input[type="text"],
		input[type="tel"],
		textarea {
			padding: 10px;
			border: 1px solid #ccc;
			border-radius: 5px;
			font-size: 16px;
			width: 100%;
			max-width: 100%;
		}

		input[type="text"],
		input[type="tel"] {
			margin-left: 20px;
		}

		button[type="submit"] {
			background-color: #008CBA;
			color: white;
			border: none;
			padding: 10px 20px;
			border-radius: 5px;
			font-size: 16px;
			cursor: pointer;
			margin-top: 20px;
			max-width: 100%;
			transition: background-color 0.3s ease-in-out;
		}

		button[type="submit"]:hover {
			background-color: #004c8c;
		}

		@media only screen and (max-width: 600px) {
			.form-title {
				font-size: 24px;
			}

			label {
				font-size: 16px;

			}

			input[type="text"],
			input[type="tel"],
			textarea {
				font-size: 14px;
			}

			input[type="text"],
			input[type="tel"] {
				margin-left: 0;
				margin-top: 10px;
			}
		}
	}

	.IntroduceTitle {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 10vh;

		.IntroduceTitleBg {
			height: 65%;
			width: 30%;
			background-color: rgb(179, 108, 108);
		}

		.IntroduceTitleFont {
			z-index: 3;
			position: absolute;
			display: flex;
			flex-direction: column;
			align-items: center;
			color: #7b0000;
			flex-wrap: nowrap;
			display: flex;
			width: 100%;

			.IntroduceTitleFontChild {
				font-weight: bold;
				font-size: 1.3rem;
			}

			.IntroduceTitleFontChild1 {
				font-size: 0.5rem;
			}
		}
	}
}

.text-container {
	padding: 10px 10px 10px 10px;
	font-size: 12px;
	color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/iphone/loanApplication.vue